export const m22Fields = [
    { identifier: 'm22-padding', type: 'input', field: 'm22-padding' },
    { identifier: 'm22-p-font-size', type: 'input', field: 'm22-p-font-size' }
]
